import type { FC } from 'react';

import { SubmitButton, Typography } from '@capsule/consumer-design-system';

import { motion } from 'framer-motion';
import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

export const ImgContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.space.s6} 0 ${({ theme }) => theme.space.s7};
`;
export const StyledSVG = styled(InlineSVG)`
  width: 234px;
  margin: 0 auto;
`;

export const CardHeaderText = styled(Typography)`
  color: ${({ theme }) => theme.colors.capsuleBlue50};
  margin-bottom: ${({ theme }) => theme.space.s2};
`;

export const StyledSubmitButton = styled(SubmitButton).attrs({ isFullWidth: true })`
  margin-top: ${({ theme }) => theme.space.s8};
`;

const ANIMATION_DURATION = 0.75; // seconds
export const CardAnimation: FC = ({ children }) => (
  <motion.div
    animate={{ y: 0, opacity: 1 }}
    initial={{ y: 100, opacity: 0 }}
    transition={{ duration: ANIMATION_DURATION }}
  >
    {children}
  </motion.div>
);

export const InputAnimation: FC = ({ children }) => (
  <motion.div
    animate={{ height: '76px', overflow: 'hidden', transitionEnd: { overflow: 'visible' } }}
    initial={{ height: '0px', overflow: 'hidden' }}
    exit={{ height: '0px', opacity: 0, overflow: 'hidden' }}
    transition={{ duration: ANIMATION_DURATION }}
  >
    {children}
  </motion.div>
);
